<template>
    <nav class="navbar has-shadow" role="navigation" aria-label="main navigation">
        <div class="container">
            <div class="navbar-brand">
                <router-link to="/doctor/login" class="navbar-item has-text-weight-bold has-icon">
                    <span>Tooddoc</span>
                    <span class="tag is-primary ml-1" style="font-size: 0.5rem" v-if="FIREBASE_PROJECT_ID == 'tooddoc-dev'">DEV</span>
                </router-link>
                <div class="navbar-item is-hidden-desktop v-flex">
                    <p class="control is-fullwidth has-text-right">
                        <router-link :to="{ name: 'doctor.profile' }" class="is-hidden-mobile button is-primary is-outlined mr-2">
                            <avatar :avatar="doctor.avatar" :name="doctor.firstName + ' ' + doctor.lastName" class="mr-2" v-if="doctor"></avatar>
                            <span>{{ $t('my_profile_link_label') }}</span>
                        </router-link>
                        <button @click.prevent="logout" class="button is-danger">
                            <span>{{ $t('logout_link_label') }}</span>
                        </button>
                    </p>
                </div>
            </div>
            <div class="navbar-menu">
                <div class="navbar-start">
                    <router-link :to="{ name: 'doctor.dashboard' }" class="navbar-item">
                        {{ $t('dashboard_link_label') }}
                    </router-link>
                    <router-link :to="{ name: 'doctor.availabilities' }" class="navbar-item">
                        {{ $t('my_availabilities_link_label') }}
                    </router-link>
                    <router-link :to="{ name: 'doctor.emergencies' }" class="navbar-item">
                        {{ $t('find_emergencies_link_label') }}
                    </router-link>
                </div>
                <div class="navbar-end">
                    <div class="navbar-item">
                        <p class="control">
                            <router-link :to="{ name: 'doctor.profile' }" class="button is-primary is-outlined mr-2">
                                <avatar :avatar="doctor.avatar" :name="doctor.firstName + ' ' + doctor.lastName" class="mr-2" v-if="doctor"></avatar>
                                <span>{{ $t('my_profile_link_label') }}</span>
                            </router-link>
                            <button @click.prevent="logout" class="button is-danger">
                                <span>{{ $t('logout_link_label') }}</span>
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import helpers from '@/mixins/helpers'
    import { store } from '@/store'

    export default {

        mixins: [helpers],

        data() {
            return {
                FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID
            }
        },

        methods: {
            logout () {
                store.dispatch('logout', {name: 'doctor.login'})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/AppNav.vue